import { useLayoutEffect } from 'preact/hooks';

import { usePlayer } from './PlayerProvider';

export function useJWPlayerEvent<T extends keyof jwplayer.EventParams>(
  eventName: T | readonly T[],
  listener: jwplayer.EventCallback<jwplayer.EventParams[T]>
): void {
  const player = usePlayer();

  useLayoutEffect(() => {
    const jw = player.getJWPlayer();
    if (!listener || !jw) {
      return;
    }

    const name = Array.isArray(eventName) ? eventName.join(' ') : eventName;

    jw.on(name, listener);

    return () => {
      jw.off(name, listener);
    };
  }, [player, eventName, listener]);
}
